'use client';

import { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import {
  Accordion,
  AccordionItem,
  AccordionSummary,
  AccordionDetails,
} from '@packages/shared/src/ui/Accordion/Accordion';
import { StatusChip } from '@packages/shared/src/ui/StatusChip/StatusChip';
import { APlus } from '@packages/modules/src/APlus/APlus';
import type { APlusData, APlusItems } from '@packages/modules/src/APlus/types';
import type { PriceCurrency } from '@packages/gql/generated/shopping/graphql';

type AplusAccordionProps = {
  items: APlusItems;
  currency: PriceCurrency;
  onChangeHandler: (data: APlusData) => void;
};

export const AplusAccordion = ({ items, currency, onChangeHandler }: AplusAccordionProps) => {
  const [accordionKey, setAccordionKey] = useState('aplus');

  return (
    <Accordion type="single" collapsible value={accordionKey} onValueChange={setAccordionKey}>
      <AccordionItem value="aplus" noStyle>
        <AccordionSummary className="text-size-body-sm">
          {accordionKey !== 'aplus' && (
            <StatusChip color="success" className="mr-2">
              <FormattedMessage id="Aplus.hint" defaultMessage="TIPP" />
            </StatusChip>
          )}
          <FormattedMessage id="Aplus.order" defaultMessage="Services jetzt dazu bestellen" />
        </AccordionSummary>
        <AccordionDetails>
          <APlus
            layout="ListItems"
            items={items}
            currency={currency}
            onChangeHandler={onChangeHandler}
          />
        </AccordionDetails>
      </AccordionItem>
    </Accordion>
  );
};
